const presetTypes = ['LOAD_SOLUTIONS_CONFIG', 'UPDATE_SOLUTION_CONFIG', 'CREATE_SOLUTION_CONFIG'];

export default presetTypes;
